/**
  * This program is free software; you can redistribute it and/or
  * modify it under the terms of the GNU General Public License
  * as published by the Free Software Foundation; under version 2
  * of the License (non-upgradable).
  *
  * This program is distributed in the hope that it will be useful,
  * but WITHOUT ANY WARRANTY; without even the implied warranty of
  * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  * GNU General Public License for more details.
  *
  * You should have received a copy of the GNU General Public License
  * along with this program; if not, write to the Free Software
  * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
  *
  * Copyright (c) 2024 (original work) Open Assessment Technologies SA;
  */
import { writable, get } from 'svelte/store';

/**
 * Creates diagnostic settings store
 * Settings there are related to a specific computer in school (e.g. ip address and choice of FLA assessment)
 * @returns {Object}
 */
function createDiagnosticSettingsStore() {
    const diagnosticSettingsValues = writable({
        isRunningAudioTest: false,
        ipAddress: '127.0.0.1'
    });

    return {
        subscribe: diagnosticSettingsValues.subscribe,
        async updateValue(key, newValue) {
            diagnosticSettingsValues.update(s => ({
                ...s,
                [key]: newValue
            }));
            await this.storeValues();
        },
        async storeValues() {
            const storage = await sessionStorage;
            storage.setItem('diagnosticSettings', JSON.stringify(get(diagnosticSettingsValues)));
        },
        async restoreValues() {
            const storage = await sessionStorage;

            let values = {};
            try {
                const unparsedValues = await storage.getItem('diagnosticSettings');
                values = JSON.parse(unparsedValues);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.warn('Couldn\'t parse school settings values from session storage');
            } finally {
                diagnosticSettingsValues.set(values);
            }
        },
        updateIpAddress(value) {
            this.updateValue('ipAddress', value);
        },
        updateAudioTestSetting(value) {
            this.updateValue('isRunningAudioTest', value);
        }
    }
}

export default createDiagnosticSettingsStore();